import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { AnimatePresence } from 'framer-motion'
import { RequestProvider } from '../../../../context/RequestContext'
import { Services } from '../../service/Services'
import { openModal } from '../../../../service/modal-service'
import { HandymanBooking } from './HandymanBooking'
import { HandymanDealItems } from './HandymanDealItems'
import { StickyCta } from '@/commons/service-hub/StickyCta'

// The booking widget, the service search sheet, the request modal and the
// sticky CTA, packaged for the price and job pages.
//
// HandymanServiceRequestFormSlug does the same job for the WordPress [slug]
// pages, but it autoplays a hero video and needs a WordPress `post`. These
// pages render their own compact hero and H1, so this panel has neither.
export const HandymanBookingPanel = ({
    requestCategorySettings,
    handymanPriceList,
    countryName = 'Singapore',
    handymanType = 'Handyman',
    defaultServiceType,
    allowedServiceTypes,
    allowedCategories,
    whatsAppText,
    variant,
}) => {
    const router = useRouter()
    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isShowDealItems, setIsShowDealItems ] = useState(false)

    // Handyman bookings always start from the priced job picker, never the
    // question wizard (which lacks most jobs and their details). A
    // ?requestForm=true link opens the picker.
    useEffect(() => {
        if (router.query.requestForm) setIsShowDealItems(true)
    }, [router.query.requestForm])

    const openRequestForm = () => {
        window.scrollTo({ top: 0 })
        openModal(setRequestForm)
    }

    return (
        <RequestProvider>
            <div id="book" className="scroll-mt-20">
                <HandymanBooking
                    requestCategorySettings={requestCategorySettings}
                    setRequestForm={setRequestForm}
                    handymanType={handymanType}
                    setIsQuickBook={setIsQuickBook}
                    countryName={countryName}
                    setIsShowDealItems={setIsShowDealItems}
                    defaultServiceType={defaultServiceType}
                    allowedServiceTypes={allowedServiceTypes}
                    handymanPriceList={handymanPriceList}
                    variant={variant}
                />
            </div>
            {isShowDealItems &&
                <AnimatePresence>
                    <HandymanDealItems requestCategorySettings={requestCategorySettings}
                        handymanPriceList={handymanPriceList}
                        setRequestForm={setRequestForm}
                        setIsQuickBook={setIsQuickBook}
                        openRequestForm={openRequestForm}
                        setIsShowDealItems={setIsShowDealItems}
                        allowedCategories={allowedCategories}
                    />
                </AnimatePresence>
            }
            {requestForm &&
                <Services requestType="Handyman Services" requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
            }
            {!requestForm && !isShowDealItems &&
                <StickyCta onBook={() => setIsShowDealItems(true)} whatsAppText={whatsAppText} spacer={false} />
            }
        </RequestProvider>
    )
}
